var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading pad text-center has-text-grey-light"},[(_vm.text)?_c('div',{staticClass:"pad"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_c('font-awesome-icon',{attrs:{"icon":"spinner","size":_vm.size,"pulse":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }